var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-avatar"},[_c('v-gravatar',{staticClass:"profile-avatar__gravatar",attrs:{"email":_vm.email,"size":_vm.size,"default-img":"blank"}}),_c('div',{staticClass:"profile-avatar__default"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }